import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import {useTranslation} from "react-i18next";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText,
    Button
} from "reactstrap";
import {NavLink as RouterNavLink} from "react-router-dom";

const NavbarComponent = () => {
    const {logout} = useAuth0();
    const {t} = useTranslation('navbar');
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <Navbar color="light" light expand="md" className="mb-4">
            <RouterNavLink className="navbar-brand" to="/">{t('title')}</RouterNavLink>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="me-auto" navbar>
                    <NavItem>
                        <RouterNavLink className="nav-link" to="/posts">
                            {t('menuItemPosts')}
                        </RouterNavLink>
                    </NavItem>
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            Options
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem>
                                Option 1
                            </DropdownItem>
                            <DropdownItem>
                                Option 2
                            </DropdownItem>
                            <DropdownItem divider/>
                            <DropdownItem>
                                Reset
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
                <NavbarText>
                    <Button onClick={() => logout()}>Logout</Button>
                </NavbarText>
            </Collapse>
        </Navbar>
    );
};

export default NavbarComponent;